<template>
  <v-container fluid class="pa-0 ma-0" style="background-color: white">
    <v-row class="ma-0 pa-0">
      <v-col lg="9" md="9" sm="12" xs="12" class="ma-0 pa-0">
        <v-img
          class="ma-0 pa-0"
          height="100vh"
          :src="'/header.jpeg'"
          :lazy-src="'/header_lazy.jpeg'"
          cover
        />
      </v-col>

      <v-col lg="3" md="3" sm="12" xs="12" class="pa-3 pt-6 fill-height">
        <v-img
          alt="Logo"
          class="shrink flex-grow-0"
          :src="'/haskoning-logo.png'"
          transition="scale-transition"
          height="70"
          width="240"
        />
        <div>
          <AuthenticationCard />
        </div>
      </v-col>
    </v-row>
    <v-overlay :model-value="loading" scrim="white" width="100%">
      <v-progress-linear color="primary" indeterminate size="64" />
    </v-overlay>
  </v-container>
</template>

<script>
import AuthenticationCard from '@/components/authentication/AuthenticationCard.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'AuthenticationView',
  components: { AuthenticationCard },
  data: () => ({
    username: null,
    error: false
  }),
  computed: {
    ...mapState('users', {
      currentUser: (state) => state.currentUser,
      loading: (state) => state.loading
    }),
    ...mapGetters('users', {
      accessibleProject: 'getAccessibleProject'
    })
  },
  methods: {
    ...mapActions('users', {
      setUser: 'setUser',
      fetchUser: 'fetchUser'
    }),
    ...mapActions('authenticate', {
      setLoggedIn: 'setLoggedIn'
    }),
    async reAuthentication() {
      try {
        await this.fetchUser()
        if (this.currentUser) {
          this.setLoggedIn(true)
        }
      } catch (e) {
        this.setLoggedIn(false)
        if (e.response.status === 401) {
          console.log('The token is not correct, please log in again')
        }
      }
    }
  },
  async mounted() {
    if (window.location.hash.indexOf('#access=') > -1) {
      const tokens = window.location.hash.split('#').filter((item) => item)
      const access = tokens.find((item) => item.includes('access=')).split('access=')[1]
      const refresh = tokens.find((item) => item.includes('refresh=')).split('refresh=')[1]
      window.location.hash.replace('#access=', '')
      window.location.hash.replace('#refresh=', '')
      localStorage.setItem('access', access)
      localStorage.setItem('refresh', refresh)
      await this.fetchUser()
      await this.$router.replace({ path: '/' })
      this.setLoggedIn(true)
    } else {
      const accessToken = localStorage.getItem('access')
      const refreshToken = localStorage.getItem('refresh')
      if (accessToken && refreshToken) {
        await this.reAuthentication()
      }
    }
  }
}
</script>
